import { Box, Chip, Tooltip, Typography } from "@mui/material";
import dayjs from "dayjs";

export const EmployeeTicketReportColumns = [
  {
    field: "ticket_number",
    headerName: "Ticket No.",
    flex: 1,
    renderCell: (params) => {
      return (
        <a
          href={`/tickets/${params.row.ticket_id}`}
          target="_blank"
          rel="noreferrer"
        >
          <Tooltip title={params.row.ticket_number}>
            <Typography>{params.row.ticket_number}</Typography>
          </Tooltip>
        </a>
      );
    },
  },
  {
    field: "ticket_title",
    headerName: "Title",
    flex: 1.5,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.ticket_title}>
          <Typography color="initial">{params.row.ticket_title}</Typography>
        </Tooltip>
      );
    },
  },
  {
    field: "employee_name",
    headerName: "Employee",
    flex: 1.5,
    renderCell: (params) => {
      return (
        <Box>
          <Typography color="initial">{params.row.employee_name}</Typography>
          <Typography variant="caption" color="initial">
            {params.row.employee_job_title}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "employee_department",
    headerName: "Employee Department",
    flex: 1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.employee_department}>
          <Typography color="initial">
            {params.row.employee_department}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    field: "ticket_date",
    headerName: "Ticket Date",
    flex: 1.5,
    renderCell: (params) => {
      return (
        <Typography color="initial">
          {dayjs(params.row.ticket_date).format("YYYY-MM-DD HH:mm")}
        </Typography>
      );
    },
  },
  {
    field: "operator_duration_in_minutes",
    headerName: "Operator Duration",
    flex: 1,
    renderCell: (params) => {
      return (
        <Typography color="initial">
          {params.row.operator_duration_in_minutes != null
            ? `${params.row.operator_duration_in_minutes} min`
            : "-"}
        </Typography>
      );
    },
  },
  {
    field: "ticket_status",
    headerName: "Status",
    flex: 1,
    renderCell: (params) => {
      return (
        <Chip
          label={params.row.ticket_status.toUpperCase().replace("_", " ")}
          size="small"
          color={
            params.row.ticket_status === "open" ||
            params.row.ticket_status === "re_open"
              ? "success"
              : params.row.ticket_status === "in_progress"
              ? "warning"
              : "error"
          }
          sx={{ mb: "3px" }}
        />
      );
    },
  },
  {
    field: "current_department",
    headerName: "Current Department",
    flex: 1.5,
    renderCell: (params) => {
      return (
        <Tooltip title={params.row.current_department}>
          <Typography color="initial">
            {params.row.current_department}
          </Typography>
        </Tooltip>
      );
    },
  },
];

